export default __webpack_public_path__ + "static/media/bg-Hex-Gradient-White.4c6caecc.jpg";